export class Port {
    id: number;
    name: string;
    type: string;
}
